export class Coordinates {
  latitude: number = 0;
  longitude: number = 0;
}